export default {
  primary: '#2780E3',
  secondary: '#333333',
  'popup-header': '#333333'
};
